module.exports = __webpack_public_path__ + "img/130004.816622ed.png";